// import { Icons, Images } from "@/app/assets/shared";
import { Icons, Images } from "@assets/assets";

interface ServiceItem {
  icon?: any;
  title?: string;
  description?: string;
  link?: string;
  icondark?: any;
}

export const services: ServiceItem[] = [
  {
    icon: Icons?.ourServicesIcons?.AI_Development_Implementation,
    icondark: Images?.cardicon4,
    title: "AI Development and Implementation",
    description:
      "As a leading AI development company, we deliver intelligent digital solutions to streamline business operations and scale effortlessly.",
    link: "/ai-development-company",
  },
  {
    icon: Icons?.ourServicesIcons?.AI_Agent_Development,
    icondark: Images?.cardicon3,
    title: "AI Agent Development ",
    description:
      "We build intelligent AI-powered agents that automate workflows to enhance efficiency, visitor interactions, and streamline operations.",
    link: "/ai-agent-development-services",
  },
  {
    icon: Images?.newAiMvpIcon2,
    icondark: Images?.newAiMvpIcon1,
    title: "AI MVP to Production",
    description:
      "We refine and transform AI-built MVPs into production-ready solutions for real-world user adoption and create a solid foundation that supports evolving business requirements.",
    link: "/ai-mvp-production-ready",
  },
  {
    icon: Icons?.ourServicesIcons?.Mobile_App_Development,
    icondark: Images?.cardicon1,
    title: "Mobile App Development",
    description:
      "Turn your mobile app ideas into custom AI-powered mobile app solutions that bring long term business value with real results.",
    link: "/mobile-application-development",
  },
  {
    icon: Icons?.ourServicesIcons?.Web_App_Development,
    icondark: Images?.cardicon2,
    title: "Web App Development",
    description:
      "Our web app developers create smooth and responsive web applications that deliver native-app like user experience.",
    link: "/web-development",
  },
  {
    icon: Images?.newHireIcon2,
    icondark: Images?.newHireIcon1,
    title: "Hire Dedicated Developers",
    description:
      "Extend your team with our skilled team of professional designers, developers, QA, and project managers to fill skill gaps and accelerate project deliveries.",
    link: "/hire-dedicated-developers",
  },
];
